import React, { useEffect, useState } from "react";

import { MONTHLY_SUMMARY_EVENT } from "./monthlySummaryOpen";

// 결산을 앱 안에서 띄우는 자리. 화면 어디에서 열든 이 하나가 받는다.
//
// `srcDoc` 로 넣으므로 주소가 생기지 않는다. 받은 HTML 은 우리 서버가 만든 것이고
// 학원 자기 데이터라 그대로 그린다.
const MonthlySummaryViewer = () => {
  const [state, setState] = useState(null);

  useEffect(() => {
    const handle = (event) => setState(event.detail || null);
    window.addEventListener(MONTHLY_SUMMARY_EVENT, handle);
    return () => window.removeEventListener(MONTHLY_SUMMARY_EVENT, handle);
  }, []);

  useEffect(() => {
    if (state?.error) {
      window.alert("결산을 불러오지 못했습니다. 잠시 뒤 다시 눌러주세요.");
      setState(null);
    }
  }, [state]);

  // 열려 있는 동안 뒤 화면이 밀리지 않게 스크롤을 잠근다
  useEffect(() => {
    if (!state || state.error) return undefined;
    const previous = document.body.style.overflow;
    document.body.style.overflow = "hidden";
    return () => {
      document.body.style.overflow = previous;
    };
  }, [state]);

  if (!state || state.error) return null;

  return (
    <div
      style={{
        position: "fixed",
        inset: 0,
        background: "#E9EFEF",
        zIndex: 1000,
        display: "flex",
        flexDirection: "column",
      }}
    >
      <div
        style={{
          background: "#0E141B",
          color: "#fff",
          padding: "12px 16px",
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          flex: "0 0 auto",
        }}
      >
        <span style={{ fontSize: "14px", fontWeight: 800 }}>
          {state.title || "월간 진단 보고서"}
        </span>
        <button
          type="button"
          onClick={() => setState(null)}
          style={{
            background: "#00A396",
            border: "none",
            color: "#fff",
            fontWeight: 800,
            fontSize: "13px",
            padding: "8px 16px",
            cursor: "pointer",
          }}
        >
          닫기
        </button>
      </div>

      {state.loading ? (
        <div
          style={{
            flex: 1,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            color: "#5b666f",
            fontSize: "14px",
          }}
        >
          결산을 불러오는 중입니다...
        </div>
      ) : (
        <iframe
          title="월간 진단 보고서"
          srcDoc={state.html}
          style={{ flex: 1, width: "100%", border: "none" }}
        />
      )}
    </div>
  );
};

export default MonthlySummaryViewer;
